import React from 'react'
import {Grid, Typography, Button} from '@mui/material';
import colors from '../../../../colors'
import SingleInvoice from '../SingleInvoice'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useSelector, useDispatch } from 'react-redux';
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { selectAlbtelecomMobileState, displayMainUtilityView, setSelectedOffer, changeConfirmationDialogState } from '../../../../../features/albtelecomMobile/albtelecomMobileSlice';
import ConfirmationDialog from '../../../../general/ConfirmationDialog'
import { texts } from '../../../../general/texts';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
          width: "10px",
          height:"50%",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: '#FFFFFF',
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
          borderRadius: "10px",
          maxHeight:'50%'
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        },
          maxHeight:'53vh',
          overflow:'auto',
          paddingLeft:'6%',
          marginTop:'1%',
          '@media (max-width: 899px )' : {height:'80%'}
      }
  }));

const AlbtelecomMobileInvoiceList = (props) => 
{
    const dispatch = useDispatch()
    const albtelecomMobileSliceState = useSelector(selectAlbtelecomMobileState)
    const classes = useStyles();
    const [invoices, setInvoices] = React.useState([])
  
    const handleInvoiceClick = (value) =>
    {
        dispatch(setSelectedOffer(value))
        dispatch(changeConfirmationDialogState())
    }

    const handleConfirmation = () => 
    {
      dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, phone: albtelecomMobileSliceState.phone}, baseUrlKey:'services', endpoint: 'Eagle/StartOfferEagle'}))
      dispatch(changeConfirmationDialogState())
    }
    
    React.useEffect(()=>{ 
        setInvoices(albtelecomMobileSliceState.invoiceList)                                                                 
    },[albtelecomMobileSliceState.invoiceList.length])

    return(
      <>
          <Grid container p={2.4}>
              <Grid container pt={3} pb={2}>
                  <Grid container item md={1.5} xs={3} justifyContent={'left'} alignContent={'center'}  ><Button onClick={()=> {dispatch(displayMainUtilityView())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                  <Grid container item md={10} xs={8} justifyContent={'left'} alignContent={'center'}  ><Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue}} variant='h5'>{texts["message-no-offer-chosen"]}</Typography></Grid>
              </Grid>
              <Grid item md={12} className={classes.scrollBar}  maxHeight= {'53vh'} overflow= {'auto'}>
                  <List className={classes.root}>     
                      {invoices.length > 0 && invoices.map((invoice, index) => {
                          return <Grid item md={12} xs={12} key={index}><SingleInvoice utilityInfo={props.utilityInfo} contractData={invoice} isMultiSelect={false} onClick={() => {handleInvoiceClick(invoice.Id)}}/></Grid>
                      })}    
                  </List>                          
              </Grid>    
          </Grid>
          {albtelecomMobileSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={albtelecomMobileSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
      </>   
    )
}
export default AlbtelecomMobileInvoiceList
